<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 搜索框 -->
		<div class="titleView">
			<div style="display: flex;align-items: center;">
				<el-input v-model="serchValue" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput" clearable size="small"/>
				<el-button type="button" style="margin-left: 10px;" @click="handelSearchClick" size="small">搜索</el-button>
			</div>
			<div class="flex">
				<div class="m-r-10">活动日期</div>
				<el-date-picker v-model="dateValue" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handelSearchClick" size="small" class="titleDate">
				</el-date-picker>
			</div>
			<div class="flex">
				<div class="m-r-10">活动类型</div>
				<el-select v-model="activity_type" placeholder="请选择" class="titleSelect" @change="handelSearchClick" size="small">
					<el-option v-for="item in activity_types" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</div>
			<div class="flex">
				<div class="m-r-10">线上/线下</div>
				<el-select v-model="activity_model" placeholder="请选择" class="titleSelect" @change="handelSearchClick" size="small">
					<el-option v-for="item in activity_models" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</div>
			<div class="flex">
				<div class="m-r-10">活动状态</div>
				<el-select v-model="statusValue" placeholder="请选择" class="titleSelect" @change="handelSearchClick" size="small">
					<el-option v-for="item in statuss" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</div>
			<div style="flex: 1;display: flex;justify-content: flex-end;">
				<el-button type="warning" class="addClick" @click="handleResetClick" size="small">重置</el-button>
				<el-button class="addClick" @click="handleAddClick" size="small">新建活动</el-button>
			</div>
		</div>

		<!-- 表格 -->
		<div class="tableView">
			<el-table :data="tableData">
				<el-table-column prop="name" label="活动名称" :key="1" align="center">
				</el-table-column>
				<el-table-column prop="activity_type" label="活动类型" :key="2" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.activity_type == 1">充值</span>
						<span v-if="scope.row.activity_type == 2">消费</span>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" :key="3" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1">未进行</span>
						<span v-if="scope.row.status == 2">进行中</span>
						<span v-if="scope.row.status == 3">已结束</span>
						<span v-if="scope.row.status == 4">已停用</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="活动说明" :key="4" align="center">
				</el-table-column>
				<el-table-column prop="start_time" label="开始日期" :key="5" align="center">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.start_time)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="exprice_time" label="截止日期" :key="6" align="center">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.exprice_time,'YYYY-MM-DD HH:mm:ss')}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" :key="7" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-if="scope.row.status == 2" @click="handelStopClick(scope.row)">暂停</el-button>
						<el-button type="text" size="small" v-if="scope.row.status != 2" @click="handelDeleteClick(scope.row)">删除</el-button>
						<el-button type="text" size="small" @click="handelEditClick(scope.row,1)">查看</el-button>
						<el-button type="text" size="small" v-if="scope.row.status != 2" @click="handelEditClick(scope.row,2)">编辑</el-button>
						<el-button type="text" size="small" v-if="scope.row.status == 4" @click="handelStartClick(scope.row)">启动</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
		</div>
	</div>
</template>

<script>
	import {
		getList,
		startActivit,
		stopActivit,
		getInfo,
		deleteActive
	} from "@/api/purchaseApi.js"
	import page from "../../components/page.vue"
	export default {
		components: {
			page
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				serchValue: '', //搜索
				fixedHeight: '',
				dateValue: [], //活动日期
				activity_model: -1, //线上线下值
				activity_models:[{  //线上线下列表
					label: '全部',
					value: -1,
				}, {
					label: '线上',
					value: 1
				}, {
					label: '线下',
					value: 2
				}],
				activity_type: -1, //活动类型值
				activity_types: [{ //活动类型列表
					label: '全部',
					value: -1
				}, {
					label: '充值',
					value: 1
				}, {
					label: '消费',
					value: 2
				}],
				statusValue: -1, //活动状态值
				statuss: [{ //活动状态列表
					label: '全部',
					value: -1
				}, {
					label: '未进行',
					value: 1
				}, {
					label: '进行中',
					value: 2
				}, {
					label: '已结束',
					value: 3
				}, {
					label: '已停用',
					value: 4
				}],
				tableData: [], //表格数据
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 106;
			this.getTableData()
		},
		methods: {
			//搜索
			handelSearchClick(){
				this.page.page = 1;
				this.getTableData()
			},
			//删除
			handelDeleteClick(row){
				this.$confirm('是否删除该活动？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id:row._id,
						name:row.name
					}
					deleteActive(params).then((res)=>{
						if(res.code == 0){
							console.log(res)
							this.$message({
								type: 'info',
								message: '已删除'
							})
							this.getTableData()
						}
					})
				})
			},
			//编辑与查看
			handelEditClick(row,type){
				console.log(row,type)
				let params = {
					id:row._id
				}
				getInfo(params).then((res)=>{
					if(res.code == 0){
						console.log(res)
						let query = {
							type:type,
							activitInfo:JSON.stringify(res.data)
						}
						console.log(query)
						this.$router.push({path: 'addhuodong',query})
					}
				})
			},
			//暂停
			handelStopClick(row){
				this.$confirm('是否暂停该活动？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id:row._id,
						name:row.name
					}
					stopActivit(params).then((res)=>{
						if(res.code == 0){
							console.log(res)
							this.$message({
								type: 'info',
								message: '已暂停'
							})
							this.getTableData()
						}
					})
				})
			},
			//启动活动
			handelStartClick(row){
				this.$confirm('是否启动该活动？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id:row._id,
						name:row.name
					}
					startActivit(params).then((res)=>{
						if(res.code == 0){
							console.log(res)
							this.$message({
								type: 'success',
								message: '已启动'
							})
							this.getTableData()
						}
					})
				})
			},
			//格式化日期
			timeFormat(time){
				let date = Number(time)*1000; 
				if (date === undefined) { 
					return ""; 
				} 
				let moment = require("moment");
				return moment(date).format("YYYY-MM-DD HH:mm:ss"); 
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//获取列表
			getTableData() {
				//获取开始时间和结束时间
				let startTime = '';
				let endTime = '';
				console.log(this.dateValue)
				if(this.dateValue.length == 0){
					startTime = '';
					endTime = '';
				}else{
					startTime = new Date(this.dateValue[0]).getTime()/1000;
					endTime = new Date(this.dateValue[1]).getTime()/1000;
				}
				let pamars ={
					page_index:this.page.page,
					page_size:this.page.pageSize,
					keyword:this.serchValue,
					status:this.statusValue,
					start_time:startTime,
					exprice_time:endTime,
					activity_model:this.activity_model,
					activity_type:this.activity_type,
				}
				// console.log(pamars)
				getList(pamars).then((res)=>{
					console.log(res)
					if (res.code == 0) {
						this.tableData = res.data.list;
						this.page.total = res.data.count;
					}
				})
			},
			// 重置
			handleResetClick() {
				this.page.page = 1;
				this.serchValue = '';
				this.dateValue = [];
				this.activity_model = -1;
				this.activity_type = -1;
				this.statusValue = -1;
				this.getTableData()
			},
			// 新建活动
			handleAddClick() {
				this.$router.push({path: 'addhuodong'})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.titleView {
		height: 72px;
		line-height: 72px;
		display: flex;
		background: #fff;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;
		font-size: 12px;
		padding: 0 10px;
		
		.titleInput {
			width: 130px;
		}

		.titleDate {
			width: 340px;
		}

		.titleSelect {
			width: 80px;
		}
	}
	
	.flex {
		display: flex;
		align-items: center;
		margin-left: 10px;
	}

	.m-r-10 {
		margin-right: 10px;
		font-size: 12px;
	}
	.tableView{
		padding-bottom: 10px;
		background: #fff;
	}
</style>
